export default __webpack_public_path__ + "images/order_management.svg";